const getDefaultState = () => {
  return {
    nomeGestioneEccezioni: "",
    cognomeGestioneEccezioni: "",
    idSocietaGestioneEccezioni: null,
    societaDenominazioneGestioneEccezioni: null,

    rowsToSkipGestioneEccezioni: 0,
    fetchRowsGestioneEccezioni: 25,
    currentPageGestioneEccezioni: 1,
    sortColumnGestioneEccezioni: "Anno",
    sortOrderGestioneEccezioni: "DESC",
  };
};
const state = getDefaultState();

const getters = {
  nomeGestioneEccezioni: (state) => state.nomeGestioneEccezioni,
  cognomeGestioneEccezioni: (state) => state.cognomeGestioneEccezioni,
  idSocietaGestioneEccezioni: (state) => state.idSocietaGestioneEccezioni,
  societaDenominazioneGestioneEccezioni: (state) =>
    state.societaDenominazioneGestioneEccezioni,

  rowsToSkipGestioneEccezioni: (state) => state.rowsToSkipGestioneEccezioni,
  fetchRowsGestioneEccezioni: (state) => state.fetchRowsGestioneEccezioni,
  currentPageGestioneEccezioni: (state) => state.currentPageGestioneEccezioni,
  sortColumnGestioneEccezioni: (state) => state.sortColumnGestioneEccezioni,
  sortOrderGestioneEccezioni: (state) => state.sortOrderGestioneEccezioni,
};

// const actions = {};
const mutations = {
  setNomeGestioneEccezioni: (state, value) => {
    state.nomeGestioneEccezioni = value;
  },
  setCognomeGestioneEccezioni: (state, value) => {
    state.cognomeGestioneEccezioni = value;
  },
  setSocietaDenominazioneGestioneEccezioni: (state, value) => {
    state.societaDenominazioneGestioneEccezioni = value;
  },
  setIdSocietaGestioneEccezioni: (state, value) => {
    state.idSocietaGestioneEccezioni = value;
  },

  setFetchRowsGestioneEccezioni: (state, value) => {
    state.currentPageGestioneEccezioni = 1;
    state.rowsToSkipGestioneEccezioni = 0;
    state.fetchRowsGestioneEccezioni = value;
  },
  setCurrentPageGestioneEccezioni: (state, value) => {
    state.currentPageGestioneEccezioni = value;
    state.rowsToSkipGestioneEccezioni = parseInt(
      (state.currentPageGestioneEccezioni - 1) *
        state.fetchRowsGestioneEccezioni
    );
  },
  setSortColumnGestioneEccezioni: (state, value) => {
    state.sortColumnGestioneEccezioni = value;
  },
  setSortOrderGestioneEccezioni: (state, value) => {
    state.sortOrderGestioneEccezioni = value;
  },
  resetFiltersGestioneEccezioni: (state) => {
    Object.assign(state, getDefaultState());
  },
  setRowsToSkipGestioneEccezioni: (state) => {
    state.currentPageGestioneEccezioni = 1;
    state.rowsToSkipGestioneEccezioni = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
